import { Button } from 'antd'
import { useNavigate } from 'react-router-dom'

import { useUserStore } from '../../../../entities/user/stores/user.store'
import { LocalStorageService } from '../../../../utils/local-storage-service/local-storage-service'

export const ConfirmEmail = () => {
  const navigate = useNavigate()
  const isQuizPassed = useUserStore((state) => state.user?.isQuizPassed)
  const updateUser = useUserStore((state) => state.updateUser)

  return (
    <div className="w-50 m-auto">
      <h2 className="mt-3 mb-5">Confirm Email</h2>

      <div className="step-wrapper row bg-white rounded-4 py-4 px-3 px-md-5 mb-5 w-100">
        Confirmation letter has been sent to your email. Please check your inbox and click the link to confirm your email address.
      </div>
      <div className="d-flex justify-content-between gap-3">
        <div>
          <Button
            onClick={() => navigate(`/auth/register`)}
            size="large"
          >
            Back
          </Button>
        </div>
        <div className="d-flex gap-3">
          <Button size="large">Resend email</Button>
          <Button
            onClick={() => {
              if (isQuizPassed) {
                navigate(`/workspace`)
              } else {
                navigate(`/onboarding`)
              }
              //TODO: replace any type
              updateUser({
                isEmailConfirmed: true,
              })
              LocalStorageService.remove('userRegisterData')
            }}
            size="large"
            type="primary"
          >
            Confirm email
          </Button>
        </div>
      </div>
    </div>
  )
}
